import React, { useState } from 'react'
import { GraviButton } from '@gravitate-js/excalibrr'
import { LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { useThemeContext } from '@gravitate-js/excalibrr'
import _ from 'lodash'

export const LockButton = ({
  isLocked,
  defaultIsLocked,
  onClick,
  className,
  classNameLocked,
  classNameUnlocked,
  disabled,
}) => {
  const [lockedState, setLockedState] = useState(defaultIsLocked === true)
  onClick = _.isFunction(onClick) ? onClick : () => {}

  if (_.isNil(isLocked)) {
    // if we're not managing the locked state outside of the component, leverage our state
    return (
      <GraviButton
        className={`${className} ${isLocked ? classNameLocked : classNameUnlocked}`}
        onClick={() => {
          setLockedState((prevState) => !prevState)
          onClick(!lockedState)
        }}
        icon={lockedState ? <LockOutlined /> : <UnlockOutlined />}
        appearance={lockedState ? 'solid' : 'text'}
        size='small'
      />
    )
  } else {
    // if isLocked is passed in, the button's state is managed elsewhere
    return (
      <GraviButton
        data-cy={isLocked ? 'unlock-btn' : 'lock-btn'}
        className={`${className} ${isLocked ? classNameLocked : classNameUnlocked}`}
        onClick={() => {
          onClick(!isLocked)
        }}
        icon={isLocked ? <LockOutlined /> : <UnlockOutlined />}
        disabled={disabled}
        appearance={isLocked ? 'dashed' : 'text'}
        shape='circle'
        size='small'
      />
    )
  }
}
